import React, { createContext, useContext, useState, useEffect, useRef, useCallback } from 'react';

const EditorStateContext = createContext();
const EditorDispatchContext = createContext();

export function EditorProvider({ children }) {
  const [editors, setEditors] = useState({});

  const registerEditor = useCallback((id, content, onSave, label) => {
    setEditors((prev) => ({
      ...prev,
      [id]: { content, onSave, label }
    }));
  }, []);

  const unregisterEditor = useCallback((id) => {
    setEditors((prev) => {
      const newEditors = { ...prev };
      delete newEditors[id];
      return newEditors;
    });
  }, []);

  return (
    <EditorStateContext.Provider value={{ editors }}>
      <EditorDispatchContext.Provider value={{ registerEditor, unregisterEditor }}>
        {children}
      </EditorDispatchContext.Provider>
    </EditorStateContext.Provider>
  );
}

export function useEditorContext() {
  return useContext(EditorStateContext);
}

export function useRegisterEditor(id, content, onSave, label) {
  const { registerEditor, unregisterEditor } = useContext(EditorDispatchContext);
  const onSaveRef = useRef(onSave);
  const contentStr = JSON.stringify(content);

  useEffect(() => {
    onSaveRef.current = onSave;
  }, [onSave]);

  useEffect(() => {
    const parsedContent = contentStr !== undefined ? JSON.parse(contentStr) : undefined;
    registerEditor(id, parsedContent, (data) => {
      if (onSaveRef.current) {
        onSaveRef.current(data);
      }
    }, label);

    return () => {
      unregisterEditor(id);
    };
  }, [id, contentStr, label, registerEditor, unregisterEditor]);
}
